// extracted by mini-css-extract-plugin
export var defaultWrapper = "_np-3";
export var downloadButton = "_np-4";
export var fileContainer = "_np-9 _np-7";
export var fileContainerBase = "_np-7";
export var fileContainerFixedHeight = "_np-8 _np-7";
export var fileInfo = "_np-5";
export var fileInfoWidthRestricted = "_np-6";
export var fileType = "_np-1";
export var fileTypeName = "_np-2";
export var image = "_np-0";
export var link = "_np-b";
export var overflowEllipsis = "_np-a";